// @tolgee-key errors.heading_status_1
// @tolgee-key errors.description_status_1
export const ErrorStatus = {
  Custom: 0,
  GroupLocked: 1,
  NotFound: '404',
  // @tolgee-key errors.heading_status_ACCEPTED
  ACCEPTED: 'ACCEPTED',
  // @tolgee-key errors.heading_status_REVOKED
  REVOKED: 'REVOKED',
} as const;

export type ErrorStatusType = (typeof ErrorStatus)[keyof typeof ErrorStatus];

export const ServerErrorCodes = {
  LOCKED_GROUP: 'group_locked',
} as const;

export type ServerErrorCodesType = (typeof ServerErrorCodes)[keyof typeof ServerErrorCodes];
